import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

const SocialIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="27.748"
      viewBox="0 0 31.714 27.748"
      y={props.yVal}
      x={props.xVal}
      fill={props.color}
      role="img"
    >
      <title>{t('Social Icon')}</title>
      <g transform="translate(0 0)">
        <g transform="translate(0 0)">
          <g transform="translate(0 0)">
            <path
              d="M11.892,5C5,5,0,8.89,0,14.249a8.3,8.3,0,0,0,1.954,5.32A5.984,5.984,0,0,1,.387,23.886a1.322,1.322,0,0,0,1.348,2.189c1.479-.488,5.42-2.138,6.46-2.577h3.7c6.891,0,11.892-3.89,11.892-9.249S18.783,5,11.892,5"
              transform="translate(0 1.606)"
            />
            <path
              d="M27.37,14.57a8.313,8.313,0,0,0,1.954-5.32c0-5.361-5-9.25-11.892-9.25-4.279,0-7.915,1.566-10,4.08A20.337,20.337,0,0,1,9.5,3.964c8.422,0,14.535,5,14.535,11.892a10.871,10.871,0,0,1-.6,3.6c1.5.617,3.268,1.325,4.153,1.617a1.293,1.293,0,0,0,.415.067,1.322,1.322,0,0,0,.934-2.256A5.971,5.971,0,0,1,27.37,14.57"
              transform="translate(2.389 0)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SocialIcon;

SocialIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
